<script>
  import { _ } from 'svelte-i18n'
  import { resetAllFilters } from '../modules/helpers'
  import { modals } from '../stores';
  import Button from '../elements/Button.svelte';
  
  function handleDeleteClick() {
    modals.open('deleteStorefront');
  }

  function handleBackClick() {
    resetAllFilters();
  }

</script>

<div class="StorefrontActions">
  <Button kind="outline" size="small" danger={true} on:click={handleDeleteClick}>Delete</Button>
  <div class="right">
    <Button kind="accent" class="right" on:click={handleBackClick}><span slot="textIcon">←</span> {$_('buttons.filterOff')}</Button>
  </div>
</div>

<style>
  .StorefrontActions {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 1rem;
    padding-top: 2px;
    margin-bottom: -2px;
  }
  .StorefrontActions .right {
    display: inline-flex;
    gap: 2rem;
    margin-left: auto;
  }
</style>